import { createAsyncAction } from '../../utils/asyncHelpers';
import { reservedItemsFetch } from '../actionHelpers/endpoints';
import { FETCH_RESERVED_ITEMS } from '../../constants/actionTypes/tsReservationActionTypes';

export const tsReservationOverviewAction = createAsyncAction(
  FETCH_RESERVED_ITEMS,
  reservedItemsFetch
);
